import { render, staticRenderFns } from "./AsIamAccounts.vue?vue&type=template&id=9e74424c&scoped=true&"
import script from "./AsIamAccounts.vue?vue&type=script&lang=js&"
export * from "./AsIamAccounts.vue?vue&type=script&lang=js&"
import style0 from "./AsIamAccounts.vue?vue&type=style&index=0&id=9e74424c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e74424c",
  null
  
)

export default component.exports